import React from 'react'
import './experience.css'

const experience = () => {
  return (
    <div className="experience" id='Experience'>

        <div className="achievement">
            <div className="circle">3+</div>
            <span>years </span>
            <span>Experience</span>
        </div>

        <div className="achievement">
            <div className="circle">20+</div>
            <span>completed </span>
            <span>Projects</span>
        </div>

        <div className="achievement">
            <div className="circle">2+</div>
            <span>Hackathons</span>
            <span>Attend</span>
        </div>

    </div>
    
  )
}

export default experience
